import axios from 'axios';
import { store } from '../store/store';
import { hideSpinner, showSpinner } from "../store/actions/loading";
import { hideNotification } from "../store/actions/notification";
import createAuthRefreshInterceptor, {
  shouldIntercept as statusCodeIntercept
} from "api/refresh-token-interceptor";
import {
  requestLogOut,
  tokenDetails
} from "store/actions/user";
import {sleep} from "api/helper";
import {
  ENDPOINT_LOGIN,
  ENDPOINT_LOGOUT,
  ENDPOINT_REFRESH
} from "config/endpoints";
import axiosShowSpinner from "api/spiner-interceptor";


function createAuthorizationInterceptors(axios) {
  axios.interceptors.request.use(function (config) {
    const state = store.getState();
    const tokenObject = state?.user?.token;

    config.headers['X-MySign-Lang'] = state.locale.lang;

    if (tokenObject)
      config.headers['Authorization'] = `Bearer ${tokenObject.access_token}`;

    return config;
  }, function (error) {
    return Promise.reject(error);
  });
}

const ignoredRefreshTokenURL = [ENDPOINT_LOGIN, ENDPOINT_REFRESH, ENDPOINT_LOGOUT];
const customAxios = axios.create();
createAuthorizationInterceptors(customAxios);
createAuthRefreshInterceptor(customAxios, {
  shouldIntercept(error, statusCodes) {
    const {url} = error.config;

    return statusCodeIntercept(error, statusCodes) && ignoredRefreshTokenURL.indexOf(url) === -1;
  },
  async handleTokenRefresh(customAxios) {
    try {
      const state = store.getState();
      const tokenObject = state.user.token;

      const rs = await customAxios.post(ENDPOINT_REFRESH, {
        refresh_token: tokenObject.refresh_token,
      });

      const {
        access_token,
        expires_at,
        refresh_token,
        expires_in
      } = rs.data.data;

      store.dispatch(tokenDetails(access_token, expires_at, refresh_token, expires_in));
      await sleep(100);

      return rs.data.data;
    } catch (_error) {
      store.dispatch(requestLogOut(true));
      // store.dispatch(tokenDetails());
      // store.dispatch(displayNotification(Types.NOTIFICATION_ERROR, Messages.UNAUTHENTICATED_ERROR));
      await sleep(100);

      return Promise.reject();
    }
  },
  setTokenData(tokenData = {}, axiosClient) {
    const {access_token} = tokenData;

    const myHeaders = new Headers(axiosClient.headers);
    myHeaders.set('Authorization', `Bearer ${access_token}`)

    axiosClient.headers = myHeaders;
  },
  attachTokenToRequest(request, tokenData = {}) {
    const {access_token} = tokenData;

    const myHeaders = new Headers(request.headers);
    myHeaders.set('Authorization', `Bearer ${access_token}`)

    request.headers = myHeaders;
  }
});

/**
 * Extending getAxios to add header Lang adn other interceptors with loading
 * @param shouldHideNotification
 * @return {AxiosInstance}
 */
export const getAxios = (shouldHideNotification = true) => {
  if (shouldHideNotification) {
    store.dispatch(hideNotification());
  }

  const removeListeners = axiosShowSpinner(customAxios, {
    onShowSpinner() {
      store.dispatch(showSpinner());
    },
    onHideSpinner() {
      store.dispatch(hideSpinner())
      removeListeners();
    }
  });

  return customAxios;
};

/**
 * Extending getAxios to add header Lang adn other interceptors without loading
 * @param shouldHideNotification
 * @return {AxiosInstance}
 */
export const getAxiosWithoutLoading = (shouldHideNotification = true) => {
  if (shouldHideNotification) {
    store.dispatch(hideNotification());
  }

  return customAxios;
};
